import { useNavigate, useSearchParams } from "react-router-dom";
import "./FeatureScreen.scss";

interface FeatureScreenProps {
  title: string;
  description?: string;
  // Optional emoji/icon shown above the title
  icon?: string;
}

/**
 * Reusable placeholder for room-object navigation targets that don't have
 * full screens implemented yet (Breathe, Journal, MyWall, Planner, etc.).
 *
 * Shows the feature title + a "Back to Rooms" button.
 * `?mode=dance|music` is read from the URL for the BreatheScreen variants.
 */
function FeatureScreen({ title, description, icon = "✨" }: FeatureScreenProps) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const mode = params.get("mode");
  const variantTitle = mode ? `${title} — ${mode}` : title;

  return (
    <div className="feature-screen">
      <button
        className="feature-screen__back"
        onClick={() => navigate(-1)}
        aria-label="Back"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Back
      </button>

      <div className="feature-screen__content">
        <div className="feature-screen__icon">{icon}</div>
        <h1 className="feature-screen__title">{variantTitle}</h1>
        {description && (
          <p className="feature-screen__description">{description}</p>
        )}
        <p className="feature-screen__hint">Coming soon</p>
      </div>
    </div>
  );
}

export default FeatureScreen;
